import { distanceUnits } from "earthbrain-viewer";

/**
 * Normalizes a unit from the upload dialog (`us_survey_feet`) or the site
 * settings (`US_SURVEY_FEET`) to the v2 API spelling; falls back to METERS.
 * @param {unknown} value
 * @returns {"METERS"|"FEET"|"US_SURVEY_FEET"}
 */
export const toApiDistanceUnit = (value) => {
	const upper = typeof value === "string" ? value.toUpperCase() : "";
	return upper === distanceUnits.FEET || upper === distanceUnits.US_SURVEY_FEET
		? upper
		: distanceUnits.METERS;
};
